import React from "react";
import { array, string } from "prop-types";

import OpinionStoryCard from "../../../molecules/OpinionStoryCard";

import "./organism2.m.css";

const Organism2 = ({ stories, publisherLang }) => {
  return stories.length > 0 ? (
    <div className="organism2" styleName="base">
      {stories.map(story => {
        const storyData = story.story;
        const headline = storyData.headline;
        const subheadline = storyData.subheadline;
        const storySlug = storyData.url;

        return (
          <OpinionStoryCard
            story={storyData}
            headline={headline}
            subheadline={subheadline}
            key={storyData.id}
            storySlug={storySlug}
            publisherLang={publisherLang}
          />
        );
      })}
    </div>
  ) : null;
};

Organism2.propTypes = {
  stories: array.isRequired,
  publisherLang: string
};

export default Organism2;
